<template>
    <div v-if="commitData" class="commit-info mt-2">
        <img v-if="commitData?.author && commitData.author?.imageUrl"
            :src="commitData.author.imageUrl" alt="Author"
            class="commit-author-img"
        />
        <span v-if="commitData?.author && commitData.author?.name" class="commit-author-name">
            {{ commitData.author.name }}
        </span>
        <span v-if="commitData?.committer && commitData.committer?.date" class="commit-date">
            • {{ formatDate(commitData.committer.date) }}
        </span>
        <span v-if="commitData?.commitId"
                class="commit-hash">
                {{ commitData.commitId.slice(0, 8) }}
            </span>
        <div v-if="commitData?.comment"
                class="commit-message">
            {{ commitData.comment }}
        </div>
    </div>
</template>

<script>
export default {
  name: 'CommitInfo',
  props: {
    commitData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
      });
    },
  },
};
</script>

<style scoped>
.commit-author-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
}
.commit-date {
    margin-left: 8px;
    color: gray;
}
.commit-hash {
    float: right;
    color: darkgray;
    font-family: monospace;
    font-size: 0.95em;
}
.commit-message {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: white;
    padding: 10px 14px;
    margin-top: 4px;
    font-size: 0.97em;
    word-break: break-word;
}
</style>
